var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"box"},[_c('cont-top'),_c('cont-main'),_c('cont-bottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }